/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

export const parseContent = (reduxObj = {}) => {
  const { data: { content } = {} } = reduxObj;
  if (!content) return { options: [], types: {} };
  let options = [];
  let types = {};
  try {
    types = JSON.parse(content);
    options = types.networktypes.map(n => ({ label: n.networks.name, value: n.networks.name }));
  } catch (err) {
    console.log('err', err);
    // err
  }
  return { options, types };
};

export const kSFOptions = [{ label: '7', value: 7 }, { label: '8', value: 8 }, { label: '9', value: 9 }];




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/util.js